import { render, staticRenderFns } from "./NonStandardHeader.vue?vue&type=template&id=4f40c396&scoped=true&"
import script from "./NonStandardHeader.vue?vue&type=script&lang=js&"
export * from "./NonStandardHeader.vue?vue&type=script&lang=js&"
import style0 from "./NonStandardHeader.vue?vue&type=style&index=0&id=4f40c396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f40c396",
  null
  
)

export default component.exports